import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n'; // Инициализация интернационализации (язык из REACT_APP_LANGUAGE)
import './index.css'; // Ensure this line is present

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 
